import React from 'react';
import styles from './Common.module.css';

import { useDispatch, useSelector } from "react-redux";
import { SettingsView } from "../settings/SettingsView";
import { PlanningView } from '../planning/PlanningView';
import { CollabsView } from '../collabs/CollabsView';
import { GroupesView } from '../groupes/GroupesView';
import { GroupeModal } from '../../components/groupes/modals/GroupeModal';
import MobileGroupeModal from '../groupes/mobile/MobileGroupeModal';
import { hideGroupeModal } from './commonSlice';
import LeavesAndAbsencesView from '../leaves/LeavesAndAbsencesView';
import { TimesheetView } from '../timesheet/TimesheetView';
import { checkPermission, isAdmin, isOwner } from '../../app/utils/helpers';
import { ReportsView } from '../reports/ReportsView';
import { config, isFeatureHidden } from '../../app/utils/config';
import EvaluationsView from '../evaluations/EvaluationsView';
import DMEvaluationsView from '../evaluations/DMEvaluationsView';
import VcompView from '../vcomp/VcompView';
import VentrView from '../ventr/VentrView';
import ClientsView from '../clients/ClientsView';
import { MedicalVisitsView } from '../medicalVisits/MedicalVisitsView';
import { OpportunitiesView } from '../opportunities/OpportunitiesView';
import { DashboardView } from '../dashboard/DashboardView';
import { ConfirmDialog } from 'primereact/confirmdialog';
import { ContractsView } from '../contracts/ContractsView';
import VSecuriteView from '../vsecurite/VSecuriteView';
import PermissionsView from '../permissions/PermissionsView';
import VReferenceView from '../vreference/VReferenceView';
import VResumeView from '../vresume/VResumeView';
import VLearnView from '../vlearn/VLearnView';

export function Body(props) {

    const dispatch = useDispatch()

    const groupeModalType = useSelector((state) => state.common.groupeModalType)
    const userRoleId = useSelector((state) => state.login.userRoleId)
    const myTeam = useSelector((state) => state.teams.myTeam);
    const selectedTeamsIds = useSelector((state) => state.teams.selectedTeamsIds)
    const isMobile = useSelector((state) => state.settings.isMobile)

    let view = <div />
    if (props.view) {
        switch (props.view.toLowerCase()) {
            case "planning":
                view = <PlanningView />
                break
            case "settings":
                view = <SettingsView />
                break
            case "groupes":
                if (checkPermission(config.scopes.groups, config.permissionTypes.view, selectedTeamsIds))
                    view = <GroupesView />
                break
            case "collabs":
                if (checkPermission(config.scopes.collabs, config.permissionTypes.view) || checkPermission(config.scopes.warnings, config.permissionTypes.view))
                    view = <CollabsView />
                break
             case "contracts":
                if (checkPermission(config.scopes.collabs, config.permissionTypes.view) || checkPermission(config.scopes.warnings, config.permissionTypes.view))
                    view = <ContractsView />
                break
            case "leaves":
                view = <LeavesAndAbsencesView />
                break
            case "timesheet":
                if (myTeam)
                    view = <TimesheetView />
                break
            case "reports":
                if (isOwner(userRoleId) || checkPermission(config.scopes.reports, config.permissionTypes.view))
                    view = <ReportsView />
                break
            case "evaluations":
                if (checkPermission(config.scopes.evaluations, config.permissionTypes.view, selectedTeamsIds))
                    view = <EvaluationsView />
                break
            case "dm-evaluations":
                if (checkPermission(config.scopes.evaluations, config.permissionTypes.view, selectedTeamsIds))
                    view = <DMEvaluationsView />
                break
            case "vcomp":
                if (checkPermission(config.scopes.vcomp, config.permissionTypes.view))
                    view = <VcompView />
                break
            case "ventr":
                view = <VentrView />
                break
            case "clients":
                if (checkPermission(config.scopes.clientsTeams, config.permissionTypes.view))
                    view = <ClientsView />
                break
            case "opportunities":
                view = <OpportunitiesView />
                break
            case "medicalvisits":
                view = <MedicalVisitsView />
                break
            case "dashboard":
                view = <DashboardView />
                break
            case "vsecurite":
                view = <VSecuriteView />
                break
            case "vreference":
                // No permission check: every collab may use the referral directory. The
                // view/edit distinction is applied per-row inside the view and enforced
                // server-side by VReferencesController. The only gate is HIDDEN_FEATURES,
                // so a bookmark to a hidden page lands on the same blank view an
                // unpermitted one already gives.
                if (!isFeatureHidden('vreference'))
                    view = <VReferenceView />
                break
            case "vresume":
                // No permission check: every collab owns and edits their own CV, so the
                // `vresume` scope does not grant entry — it only widens which OTHER people's
                // CVs the user reaches. That is a per-row decision, applied inside the view
                // from what the server reports and enforced by VResumesController.
                if (!isFeatureHidden('vresume'))
                    view = <VResumeView />
                break
            case "vlearn":
                // No permission check, for the same reason vresume and vreference have none:
                // every collab takes the courses assigned to them, so the `vlearn` scope does
                // not grant entry to V-Learning — it only widens which courses the user
                // reaches and whether they may author. That is a per-row decision, applied
                // inside the view from what the server reports and enforced by
                // VLearnBaseController. A guard here would lock every employee out of their
                // own mandatory training.
                if (!isFeatureHidden('vlearn'))
                    view = <VLearnView />
                break
            case "permissions":
                if (userRoleId == 1)
                    view = <PermissionsView />
                break
            default:
                break
        }
    }

    return <div className={styles.body}>
        {view}
        {(isMobile == 2 || isMobile == 3)
            ? <MobileGroupeModal show={groupeModalType} onHide={() => dispatch(hideGroupeModal())} />
            : <GroupeModal show={groupeModalType} onHide={() => dispatch(hideGroupeModal())} />
        }
        <ConfirmDialog />
    </div>
}